import { render, staticRenderFns } from "./indexService.vue?vue&type=template&id=4165a122&"
import script from "./indexService.vue?vue&type=script&lang=ts&"
export * from "./indexService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports